export class TipologieDistributore {
	constructor(){
		this.itemID = null;
		this.tipologia = null;
	}
	itemID: number | null;
	tipologia: string | null;
}